<template>
    <va-card class="flex mb-4">
        <va-card-title style="height: 30px; padding: 5px; padding-left: 20px"
            >日志列表</va-card-title
        >
        <va-card-content>
            <div>
                <div>
                    <vxe-form :data="toolbar.formData">
                        <vxe-form-item
                            title="虚拟机"
                            field="searchKey"
                            :item-render="{}"
                        >
                            <template #default="{ data }">
                                <vxe-select
                                    v-model="data.selectMac"
                                    :options="toolbar.macOptions"
                                    placeholder="全部"
                                    clearable
                                >
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="级别"
                            field="level"
                            :item-render="{}"
                        >
                            <template #default="{ data }">
                                <vxe-select
                                    v-model="data.level"
                                    placeholder="全部"
                                    clearable
                                    style="width: 100px"
                                >
                                    <vxe-option
                                        value="Info"
                                        label="提示"
                                    ></vxe-option>
                                    <vxe-option
                                        value="Error"
                                        label="错误"
                                    ></vxe-option>
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="系统日志"
                            field="status"
                            :item-render="{}"
                        >
                            <template #default="{ data }">
                                <vxe-select
                                    v-model="data.status"
                                    placeholder="全部"
                                    clearable
                                    style="width: 110px"
                                >
                                    <vxe-option
                                        value="0"
                                        label="不显示"
                                    ></vxe-option>
                                    <vxe-option
                                        value="1"
                                        label="显示"
                                    ></vxe-option>
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="关键字"
                            field="searchKey"
                            :item-render="{}"
                        >
                            <template #default="{ data }">
                                <vxe-input
                                    v-model="data.searchKey"
                                    placeholder="请输入姓名或邮箱"
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item>
                            <template #default>
                                <vxe-button
                                    status="primary"
                                    @click="findData"
                                    @keyup.enter="findData"
                                    >查询</vxe-button
                                >
                                <vxe-button @click="clear">重置</vxe-button>
                            </template>
                        </vxe-form-item>
                    </vxe-form>
                </div>
                <div style="overflow: hidden; height: 100%">
                    <vxe-table
                        stripe
                        class="mytable-scrollbar"
                        :data="tableData"
                        :height="tableHeight"
                        show-overflow
                        :row-config="{
                            height: 36,
                            isHover: true,
                            isCurrent: true,
                        }"
                    >
                        <vxe-column
                            type="seq"
                            field="id"
                            title="序号"
                            width="60"
                        ></vxe-column>
                        <vxe-column title="状态" width="60">
                            <template #default="{ row }">
                                <span>{{
                                    row.Level == "Info" ? "信息" : "错误"
                                }}</span>
                            </template>
                        </vxe-column>
                        <vxe-column
                            field="Level"
                            title="级别"
                            width="60"
                        ></vxe-column>
                        <vxe-column
                            field="ProcessName"
                            title="流程/项目ID"
                            width="140"
                            sortable
                            resizable
                        ></vxe-column>
                        <vxe-column
                            field="RobotName"
                            title="机器人"
                            width="160"
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="Message"
                            title="信息"
                            show-overflow
                            sortable
                            resizable
                        ></vxe-column>
                        <vxe-column
                            field="TimeStamp"
                            title="操作时间"
                            width="160"
                        ></vxe-column>
                    </vxe-table>
                </div>
                <div>
                    <vxe-pager
                        background
                        v-model:current-page="tablePager.currentPage"
                        v-model:page-size="tablePager.pageSize"
                        :total="tablePager.totalResult"
                        @page-change="handlePageChange"
                        :layouts="[
                            'PrevJump',
                            'PrevPage',
                            'JumpNumber',
                            'NextPage',
                            'NextJump',
                            'Sizes',
                            'FullJump',
                            'Total',
                        ]"
                    >
                    </vxe-pager>
                </div>
            </div>
        </va-card-content>
    </va-card>
</template>

<script>
import Qs from "qs";
import { reactive } from "vue";

export default {
    name: "LogList",
    data() {
        const pageHeight = window.innerHeight - (65 + 48 + 198) + "px"; //屏幕高度减去导航栏和内补白
        const tablePager = reactive({
            currentPage: 1,
            pageSize: 10,
            totalResult: 0,
        });
        const toolbar = reactive({
            loading: false,
            macOptions: [],
            formData: {
                searchKey: "",
                level: "",
                status: "",
                selectMac: "",
            },
        });
        return {
            tableData: null,
            tablePager,
            toolbar,
            pageHeight,
            tableHeight: 0,
        };
    },
    methods: {
        calTableHeight(rowsLength) {
            let minHeight = window.innerHeight - (65 + 28 + 198);
            let calHeight = rowsLength == null ? 0 : (rowsLength + 1) * 36 + 22;
            this.tableHeight = Math.max(minHeight, calHeight);
        },
        findData() {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: this.tablePager.currentPage,
                pageSize: this.tablePager.pageSize,
                searchKey: [
                    this.toolbar.formData.searchKey,
                    this.toolbar.formData.level,
                    this.toolbar.formData.status,
                    this.toolbar.formData.selectMac,
                ],
            };
            this.$api.jobManageAPI
                .getLogsList(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    // console.log(res.data.Data);
                    this.tableData = res.data.Data.dataTable;
                    this.tablePager.currentPage = res.data.Data.currentPage;
                    this.tablePager.pageSize = res.data.Data.pageSize;
                    this.tablePager.totalResult = res.data.Data.totalResult;
                    this.tableHeight = this.$calTableHeight(
                        res.data.Data.dataTable.length
                    );
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        handlePageChange() {
            this.findData();
        },
        bindPC() {
            this.$api.systemManageAPI
                .getMachineList()
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    // console.log(res.data.Data);
                    this.toolbar.macOptions = [];
                    for (const item of res.data.Data) {
                        this.toolbar.macOptions.push({
                            value: item.PcName,
                            label: item.Abbr,
                        });
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        clear() {
            this.toolbar.formData.searchKey = "";
            this.toolbar.formData.status = "";
            this.toolbar.formData.type = "";
            this.toolbar.formData.selectMac = "";
        },
        keydown(e) {
            if (e.keyCode === 13) {
                this.findData();
            }
        },
    },
    mounted() {
        this.bindPC();
        this.findData();
        window.addEventListener("keydown", this.keydown);
    },
    unmounted() {
        window.removeEventListener("keydown", this.keydown, false);
    },
};
</script>

<style type="text/css">
td.vxe-body--column {
    vertical-align: middle;
}
</style>
